import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Tag from '../../general/Tag'
import cardLanguages from '../../../data/cardLanguages'
import Tooltip, { StyledTooltip } from '../../general/Tooltip'
import translate from '../../../helper/translate'
import { mobile } from '../../../styles/media'

const LanguageAbbr = ({ language, noTooltip, t }) => {
	const data = cardLanguages[language]

	return (
		<StyledLanguageAbbr
			large
			color={data.color}
		>
			<Tooltip title={!noTooltip ? t(data.name) : null}>
				{data.abbr}
			</Tooltip>
		</StyledLanguageAbbr>
	)
}

const StyledLanguageAbbr = styled(Tag)`
	background: ${props => props.theme.secondary};
	border-radius: 2px;
	color: ${props => props.theme.white};
	display: inline-block;
	margin-left: 0.5rem;
	vertical-align: middle;

	${StyledTooltip} {
		text-transform: none;
	}

	${mobile`
		margin-left: 0.35rem;
		padding: 0.1rem 0.2rem;
	`}
`

LanguageAbbr.propTypes = {
	language: PropTypes.string.isRequired,
	noTooltip: PropTypes.bool,
	t: PropTypes.func.isRequired
}

LanguageAbbr.defaultProps = {
	noTooltip: false
}

const enhance = translate('general')

export default enhance(LanguageAbbr)
